const mutations = {
  setContratos (state, data) {
    state.contratos = data
  },

  setContratoAtual (state, data) {
    state.contratoAtual = data

    if (!data.marca) {
      state.contratoAtual.marca = 'nortis'
    }
  },

  setNome (state, data) {
    state.nome = data
  },

  setCodCliente (state, data) {
    state.codigoCliente = data
  },

  setPersonificado (state, data) {
    state.personificado = data
  },

  setCodUsuario (state, data) {
    state.codigoUsuario = data
  },

  setMenuInfo (state, data) {
    if (data.comunicados) state.badge = data.comunicados.total
    state.exibirPersonalizacao = data.exibirPersonalizacao
    state.exibirStatusObra = data.exibirStatusObra
  },

  setBadge (state, data) {
    state.badge = data
  },

  setDocumento (state, data) {
    state.documento = data
  },

  setEmail (state, data) {
    state.email = data
  },

  setHeaderType (state, data) {
    state.headerType = data === 4 || data === 5 ? 'catuai' : 'default'
  },

  setConjugeNome (state, data) {
    state.conjugeNome = data
  }, // setConjugeNome()

  setConjugeCPF (state, data) {
    state.conjugeCPF = data
  } // setConjugeCPF()
}

export default mutations
